<template>
  <div class="container">
    <div class="ck">
      <div class="left">
        <div class="bg">
          <div class="text-swap">
            <span class="text">欢迎您使用</span>
            <span class="text text-style-1">有看投大咖操作平台</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="bg">
          <div class="tab">
            <div
              class="tab-main"
              :class="{ active: isPassWordLogin }"
              v-on:click="isPassWordLogin = true"
            >
              <span class="e-text">账号密码登录</span>
              <div class="border"></div>
            </div>
            <div
              class="tab-main"
              :class="{ active: !isPassWordLogin }"
              v-on:click="isPassWordLogin = false"
            >
              <span class="e-text">短信快捷登录</span>
              <div class="border"></div>
            </div>
          </div>
          <div class="line"></div>
          <div class="e-input">
            <ul @keyup.enter="login">
              <li :class="{ 'e-input-error': phoneError }">
                <input
                  v-model="phone"
                  class="e-text"
                  type="text"
                  placeholder="请输入手机号"
                />
              </li>
              <li
                v-if="isPassWordLogin"
                :class="{ 'e-input-error': passwordError }"
              >
                <input
                  v-model="password"
                  class="e-text"
                  type="password"
                  placeholder="请输入密码"
                />
              </li>
              <!-- 图形验证码 -->
              <li
                v-if="isPassWordLogin || neetImgCode"
                class="e-check"
                :class="{ 'e-input-error': imageCodeError }"
              >
                <input
                  v-model="imageCode"
                  class="e-text e-code-input"
                  type="text"
                  placeholder="请输入验证码"
                />
                <a @click="getVerificationImage">
                  <img
                    class="e-imput-img"
                    :src="`data:image/png;base64,${codeImageUrl}`"
                  />
                </a>
              </li>
              <!-- 手机验证码 -->
              <li
                class="e-check"
                v-if="!isPassWordLogin"
                :class="{ 'e-input-error': smsCodeError }"
              >
                <input
                  v-model="smsCode"
                  class="e-text e-code-input"
                  type="text"
                  placeholder="输入验证码"
                />
                <div class="e-lh">
                  <span
                    @click="SendSmsCode()"
                    class="get-code"
                    :class="{ 'get-code-busy': smsCodeBtn.busy }"
                    >{{ sendSmsText }}</span
                  >
                </div>
              </li>
              <li class="error-text" v-if="hasError">
                <div class="error-text s5 c1">{{ errorText }}</div>
              </li>
            </ul>
          </div>
          <div class="e-btn">
            <el-button
              type="primary"
              class="button-login"
              :loading="loading"
              @click="login"
              >登录</el-button
            >
          </div>
          <div class="e-reg">
            <div class="s-left">
              <span>还没有账号？</span>
              <router-link to="/excl-author/regist">立即注册</router-link>
            </div>
            <div class="s-right">
              <router-link to="/excl-author/pwd-retrieve">忘记密码</router-link>
            </div>
          </div>
          <div class="agree">
            <div>
              <span>注册或登录即代表同意有看投</span>
              <a @click="goPrivacy()">隐私政策</a>
              <span>和</span>
              <a @click="goRegistAgreement()">用户协议</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getVerificationImage,
  authorLogin,
  login,
  sendSmsCode
} from '@/api/account'
import dayjs from 'dayjs'
import store from '@/store'
import router from '@/router'

function validatePhone(phone) {
  return /^1\d{10}$/.test(phone)
}

export default {
  name: 'Login',
  components: {},
  data() {
    return {
      isPassWordLogin: true,
      phone: '',
      password: '',
      imageKey: '',
      imageCode: '',
      smsCode: '',
      phoneError: false,
      passwordError: false,
      imageCodeError: false,
      smsCodeError: false,
      apiError: false,
      errorText: '',
      loading: false,
      codeImageUrl: '',
      smsCodeBtn: {
        text: '发送验证码',
        spaceMax: 60,
        space: 0,
        busy: false,
        timer: Object
      },
      neetImgCode: false
    }
  },
  created() {},
  mounted() {
    var that = this
    that.getVerificationImage()
  },
  computed: {
    hasError() {
      return (
        this.phoneError ||
        this.passwordError ||
        this.imageCodeError ||
        this.apiError
      )
    },
    sendSmsText() {
      if (this.smsCodeBtn.busy) {
        return `${this.smsCodeBtn.space}s后重新发送`
      } else {
        return `${this.smsCodeBtn.text}`
      }
    }
  },
  methods: {
    // 个人隐私
    goPrivacy() {
      var routeUrl = this.$router.resolve('/excl-author/agreement/privacy')
      window.open(routeUrl.href, '_blank')
    },
    // 使用协议
    goRegistAgreement() {
      var routeUrl = this.$router.resolve('/excl-author/agreement/regist')
      window.open(routeUrl.href, '_blank')
    },
    changeTab(index) {
      this.isPassWordLogin = index
    },
    async getVerificationImage() {
      const { result, detail } = await getVerificationImage()
      if (result.code === 0) {
        this.imageKey = detail.key
        this.codeImageUrl = detail.image
      }
    },
    showError(msg) {
      if (!msg) {
        msg = '数据请求发生异常，请稍后再试。'
      }

      this.$notify.error({
        position: 'bottom-right',
        title: '错误',
        message: msg
      })
    },
    // 发送短信验证码
    async SendSmsCode() {
      if (this.smsCodeBtn.busy) {
        return false
      }
      if (validatePhone(this.phone)) {
        this.errorText = null
        this.phoneError = false
        this.smsCodeBtn.space = this.smsCodeBtn.spaceMax
        this.smsCodeBtn.busy = true

        const { result } = await sendSmsCode(
          this.phone,
          this.imageKey,
          this.imageCode
        ).catch(data => {
          console.log('error:', data)
          this.showError()
        })
        console.log('result', result)
        if (result.code === 0) {
          // 等待
          this.smsCodeBtn.timer = setInterval(() => {
            this.smsCodeBtn.space--
            if (this.smsCodeBtn.space === 0) {
              this.smsCodeBtn.busy = false
              clearInterval(this.smsCodeBtn.timer)
            }
          }, 1000)
        } else if (result.code === 22201) {
          this.neetImgCode = true
          this.smsCodeBtn.busy = false
          this.showError(result.msg)
        } else {
          this.showError(result.msg)
          this.smsCodeBtn.busy = false
        }
      } else {
        this.errorText = '请输入正确的手机号'
        this.phoneError = true
      }
    },
    // 登录
    async login() {
      if (this.isPassWordLogin) {
        await this.loginByPwd()
      } else {
        await this.loginBySmsCode()
      }
    },
    // 短信验证码登录
    async loginBySmsCode() {
      if (!validatePhone(this.phone)) {
        this.errorText = '请输入正确的手机号'
        this.phoneError = true
        return
      }
      this.phoneError = false

      if (!/^\d{6}$/.test(this.smsCode)) {
        this.errorText = '请输入正确的验证码'
        this.smsCodeError = true
        return
      }
      if (
        (this.neetImgCode || this.isPassWordLogin) &&
        (!this.imageCode || this.imageCode.length > 6)
      ) {
        this.errorText = '请输入正确的验证码'
        this.imageCodeError = true
        return
      }
      this.imageCodeError = false
      this.smsCodeError = false

      this.loading = true
      const { result, detail } = await login(
        this.phone,
        this.smsCode,
        dayjs(+process.env.VUE_APP_VERSION).format('YYYY.M.D')
      )

      this.loading = false

      if (result.code === 0) {
        await this.loginAfter(detail)
      } else {
        this.errorText = result.msg
        this.apiError = true
        this.getVerificationImage()
      }
    },
    // 帐号密码登录
    async loginByPwd() {
      if (!validatePhone(this.phone)) {
        this.errorText = '请输入正确的手机号'
        this.phoneError = true
        return
      }
      this.phoneError = false

      if (!/^(?=.*[a-zA-Z])(?=.*\d)[\S]{6,18}$/.test(this.password)) {
        this.errorText = '请输入正确的密码'
        this.passwordError = true
        return
      }
      this.passwordError = false

      if (!this.imageCode || this.imageCode.length > 6) {
        this.errorText = '请输入正确的验证码'
        this.imageCodeError = true
        return
      }
      this.imageCodeError = false

      this.loading = true

      const { result, detail } = await authorLogin(
        this.imageKey,
        this.imageCode,
        this.phone,
        this.password
      )
      this.loading = false
      if (result.code === 0) {
        await this.loginAfter(detail)
      } else {
        this.errorText = result.msg
        this.apiError = true
        this.getVerificationImage()
      }
    },
    async loginAfter(detail) {
      this.apiError = false
      delete detail.accId
      // 设置登录信息
      store.commit('auth/setLoginInfo', detail)
      // 获取大咖基础信息
      await store.dispatch('user/getUserInfo')
      // 获取大咖基础信息
      await store.dispatch('user/getAuthorInfo')

      // 如果用户已经是大咖
      if (store.getters['user/isAuthor']) {
        // 跳转个人中心
        router.push('/excl-author/mine')
      } else {
        // 跳转注册
        router.push('/excl-author/regist')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  background-color: #f0f0f0;
  .ck {
    width: 1200px;
    height: 660px;
    // padding-top: 30px;
    align-items: center;
    display: flex;
    .left {
      width: 720px;
      justify-content: center;
      // background-color: darkmagenta;
      display: inline-flex;
      .bg {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        width: 630px;
        height: 370px;
        background: url('./images/bg-1.png') no-repeat;
        .text-swap {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          width: 277px;
          height: 61px;
          font-family: MicrosoftYaHei;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 0px;
          color: #262626;
          margin-top: -140px;
          margin-right: 15px;
        }
        .text {
          font-family: MicrosoftYaHei;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 0px;
          color: #262626;
        }
        .text-style-1 {
          font-size: 30px;
          font-weight: bold;
        }
      }
    }
    .right {
      width: 480;
      .bg {
        width: 480px;
        height: 580px;
        background-color: #ffffff;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .tab {
        width: 100%;
        height: 70px;
        display: flex;
        align-items: flex-end;
        .tab-main {
          width: 50%;
          display: flex;
          justify-content: center;
          cursor: pointer;
          flex-direction: column;
          align-items: center;
        }
        .e-text {
          width: 110px;
          font-family: MicrosoftYaHei;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 45px;
          letter-spacing: 0px;
          color: #858585;
        }
        .border {
          width: 110px;
          height: 4px;
        }
        .active {
          .border {
            background-color: #046bcc;
          }
          .e-text {
            color: #262626;
          }
        }
      }
      .line {
        width: 480px;
        height: 1px;
        background-color: #ebebeb;
      }
      .e-input {
        width: 100%;
        height: 280px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        ul {
          width: 321px;
          // height: 146px;
        }
        li {
          width: 100%;
          border-bottom: 1px solid #ebebeb;
          padding: 2px 8px;
        }

        .e-input-error {
          border-color: #e64c2e;
        }
        .error-text {
          font-size: 14px;
          border: none;
          line-height: 40px;
        }
        .e-lh {
          display: inline-flex;
          justify-content: center;
          width: 100px;
        }
        .e-text {
          width: 100%;
          font-family: MicrosoftYaHei;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 50px;
          letter-spacing: 1px;
          border: unset;
          outline: none;
        }
        .e-code-input {
          width: 220px;
        }
        .e-check {
          display: flex;
          align-items: center;
        }
        .e-imput-img {
          display: flex;
          cursor: pointer;
          width: 100px;
          height: 40px;
        }
        .get-code {
          background-color: transparent;
          font-size: 14px;
          color: #046bcc;
          outline: none;
          border: none;
          cursor: pointer;
        }
        .get-code-busy {
          color: #858585;
        }
        .e-input-error {
          border-color: red;
        }
      }
      .e-btn {
        .button-login {
          margin: 0 auto;
          width: 320px;
          height: 46px;
          border-radius: 5px;
        }
      }
      .e-reg {
        display: flex;
        width: 320px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 50px;
        letter-spacing: 0px;
        color: #858585;
        .s-left {
          width: 50%;
          font-size: 14px;
          a {
            color: #046bcc;
            cursor: pointer;
            text-decoration: none;
          }
        }
        .s-right {
          width: 50%;
          font-size: 14px;
          a,
          span {
            text-decoration: none;
            display: flex;
            justify-content: flex-end;
            cursor: pointer;
            line-height: 50px;
            letter-spacing: 0px;
            color: #858585;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
          }
        }
      }
      .agree {
        display: flex;
        height: 130px;
        justify-content: center;
        align-items: flex-end;
        span {
          width: 310px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 62px;
          letter-spacing: 0px;
          color: #858585;
        }
        a {
          font-family: PingFangSC-Regular;
          text-decoration: underline;
          font-size: 14px;
          font-weight: normal;
          letter-spacing: 0px;
          color: #046bcc;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
